export default __webpack_public_path__ + "static/media/img-3.67143e80.jpg";